import { Checkbox } from '@liveauctioneers/hammer-ui-core/checkbox';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import * as React from 'react';

import ResellerTypes from '@/enums/resellerTypes';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { getResellerType, sendResellerType } from '@/redux/modules/reseller';

type Props = {
    className?: string;
};

const ResellerCheckbox = ({ className }: Props) => {
    const { formatMessage } = useIntl();
    const dispatch = useAppDispatch();
    const resellerType = useAppSelector(getResellerType);

    const onCheckedValueChange = React.useCallback(() => {
        const newSelection =
            resellerType === ResellerTypes.NOT_A_RESELLER ? ResellerTypes.RESELLER : ResellerTypes.NOT_A_RESELLER;
        dispatch(sendResellerType(newSelection));
    }, [dispatch, resellerType]);

    return (
        <div className={className}>
            <Checkbox.Option
                checked={Boolean(resellerType)}
                className="mb-0"
                name="resellerSelection"
                onChange={onCheckedValueChange}
            >
                {formatMessage({ id: 'taxExempt' })}
            </Checkbox.Option>
        </div>
    );
};

export default ResellerCheckbox;
